import { NBSP } from 'shared/constants/symbols';
import * as styles from './styles.css';
import { SOCIALS } from 'shared/constants/socials';
import { ESocialType } from 'shared/types/socials';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

export const Footer: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['block']}>
        <div className={styles['block-title']}>Почтовый адрес</div>
        <div className={styles['block-text']}>
          236006, Россия, г.{NBSP}Калининград, ул.{NBSP}Октябрьская, д.
          {NBSP}
          37, помещ. XIV, офис{NBSP}13
        </div>
      </div>
      <div className={styles['block']}>
        <div className={styles['block-title']}>Связи с{NBSP}инвесторами</div>
        <ul className={styles['list']}>
          <li>
            <a className={styles['link']} href="mailto:ir@cian.ru">
              ir@cian.ru
            </a>
          </li>
          <li>
            <a className={styles['link']} href="tel:+74952803814">
              +7 (495) 280-38-14
            </a>
          </li>
        </ul>
      </div>
      <div className={styles['block']}>
        <div className={styles['block-title']}>Социальные сети</div>
        <ul className={styles['list']}>
          {SOCIALS.filter(item => item.id !== ESocialType.Ir).map(({ id, text, url }) => (
            <li key={id}>
              <a className={styles['social']} href={url} target="_blank" rel="noreferrer">
                <div className={clsx(styles['social-image'], styles[id])} />
                <div className={styles['social-text']}>{text}</div>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles['block']}>
        <div className={styles['block-title']}>Московский офис</div>
        <div className={styles['block-text']}>107023, Россия, г. Москва, ул.{NBSP}Электрозаводская, д. 27, стр. 8</div>
      </div>
      <div className={styles['block']}>
        <div className={styles['block-title']}>Пресс-служба</div>
        <a className={styles['link']} href="mailto:pr@cian.ru">
          pr@cian.ru
        </a>
      </div>
      <div className={styles['block']}>
        <div className={styles['block-title']}>Официальный сайт</div>
        <a className={styles['link']} href="https://ir.ciangroup.ru" target="_blank" rel="noreferrer">
          ir.ciangroup.ru
        </a>
      </div>
    </div>
  );
};
